import axios from "axios";
import { SERVER_API } from "../../Constant";

export const FetchCredits_api = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Credits/fetch_credits.php`,
      {
        params: { page, limit, search },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch credits failed:", error);
    return { error: "Fetch credits failed" };
  }
};

export const UpdateCreditStatus_api = async (id: number) => {
  try {
    const response = await axios.post(
      `${SERVER_API}/Credits/update_credit_status.php`,
      {
        id,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Update credit status failed:", error);
    return { error: "Update credit status failed" };
  }
};